import React, { } from "react";
import { Card, Stack } from "@mui/material";
import SvgDiagram from "../../SvgDiagram";

function formatInfo(value, percent) {
    const valueStr = parseFloat(value).toFixed(1);
    const percentStr = parseFloat(percent).toFixed(1);

    return `${percentStr}% / ${valueStr}kg`;
}

export default function TanitaMC780FatRadarCard({ data }) {
    const image = {
        // 1012 × 480
        w: 1012, h: 750,
        src: "/assets/tanita/mc780/body_fat_diagram.png"
    }

    // TODO: bind with data 
    const infos = [
        formatInfo(data.trunk_fat_mass, data.trunk_fat_p),
        formatInfo(data.la_fat_mass, data.la_fat_p),
        formatInfo(data.ll_fat_mass, data.ll_fat_p),
        formatInfo(data.rl_fat_mass, data.rl_fat_p),
        formatInfo(data.ra_fat_mass, data.ra_fat_p),
    ];
    const radarValues = [
        parseInt(data.trunk_fat_p_score), 
        parseInt(data.la_fat_p_score), 
        parseInt(data.ll_fat_p_score), 
        parseInt(data.rl_fat_p_score), 
        parseInt(data.ra_fat_p_score), 
    ]

    const positions = [
        [440, 140],
        [80, 320],
        [80, 570],
        [680, 570],
        [680, 320],
    ];

    const radarSetting = {
        values: radarValues, valueRange: [-4, 4],
        radarCenter: [505, 460], radarRange: [-2, 230]
    };

    const markers = [];
    markers.push(
        { type: "radar", ...radarSetting}, 
    );

    for (let i = 0; i < infos.length; i++) {
        const [x, y] = positions[i];

        markers.push({
            type: "text", x: x, y: y,
            text: infos[i],
            fontSize: 2.5,
        });
    }
    // { type: "dot", x: x, y: y, r: 10, color: "red", origin: "bottom-left" }

    // const imageW = 711;
    // const imageH = 531;
    return <Card sx={{ maxWidth: 900 }}>
        <Stack direction="column">
            <SvgDiagram image={image} markers={markers} />

        </Stack>
    </Card>
}